<template>
   <app-master>

       <div slot='breadcrumb'>
         <app-breadcrumb>
             <div class="title-box ttm-textcolor-white">
                <div class="page-title-heading">
                    <h1 class="title">Gallery</h1>
                </div><!-- /.page-title-captions -->
                <div class="breadcrumb-wrapper">
                    <div class="container">
                        <div class="breadcrumb-wrapper-inner">
                            <span>
                                <router-link class="home" title='Go to AgroPark' to='/'><i class="themifyicon ti-home"></i>&nbsp;&nbsp;Home </router-link>
            
                            </span>
                            <span class="ttm-bread-sep">&nbsp; | &nbsp;</span>
                            <span>Gallery</span>
                        </div>
                    </div>
                </div>
            </div>
         </app-breadcrumb>
       </div>
        



      <div slot='main_content'>

           <section class="ttm-row pb-70 res-991-pb-20 clearfix">
            <div class="container">
                <!-- row -->
                <div class="row multi-columns-row ttm-boxes-row-wrapper">
                    <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                        <!-- featured-imagebox -->
                        <div class="featured-imagebox featured-imagebox-portfolio">
                            <!-- featured-thumbnail -->
                            <div class="featured-thumbnail">
                                <a href="#"> <img class="img-fluid" src="/img/pig.png" alt="image"></a>
                            </div><!-- featured-thumbnail end-->
                            <!-- ttm-box-view-overlay -->
                            <div class="ttm-box-view-overlay ttm-portfolio-box-view-overlay">
                                <div class="featured-iconbox ttm-media-link">
                                    <a class="ttm_prettyphoto ttm_image" title="piggery" data-rel="prettyPhoto" href="/img/pig.png">
                                        <i class="ti ti-search"></i>
                                    </a>
                                </div>
                                <div class="ttm-box-view-content-inner">
                                    <div class="featured-content featured-content-portfolio">
                                        <div class="featured-title">
                                            <h5><a href="#">Piggery section</a></h5>
                                        </div>
                                        <!-- <span class="category">
                                            <a href="portfolio-category.html">Cardiology</a>,
                                            <a href="portfolio-category.html">Oncology</a>
                                        </span> -->
                                    </div>
                                </div>
                            </div><!-- ttm-box-view-overlay end-->
                        </div><!-- featured-imagebox -->
                    </div>
                    <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                        <!-- featured-imagebox -->
                        <div class="featured-imagebox featured-imagebox-portfolio">
                            <!-- featured-thumbnail -->
                            <div class="featured-thumbnail">
                                <a href="#"> <img class="img-fluid" src="/img/wk.png" alt="image"></a>
                            </div><!-- featured-thumbnail end-->
                            <!-- ttm-box-view-overlay -->
                            <div class="ttm-box-view-overlay ttm-portfolio-box-view-overlay">
                                <div class="featured-iconbox ttm-media-link">
                                    <a class="ttm_prettyphoto ttm_image" title="workers" data-rel="prettyPhoto" href="/img/wk.png">
                                        <i class="ti ti-search"></i>
                                    </a>
                                </div>
                                <div class="ttm-box-view-content-inner">
                                    <div class="featured-content featured-content-portfolio">
                                        <div class="featured-title">
                                            <h5><a href="#">Farm Tour</a></h5>
                                        </div>
                                        <!-- <span class="category">
                                            <a href="portfolio-category.html">Orthopedics</a>,
                                            <a href="portfolio-category.html">Pharmacy</a>
                                        </span> -->
                                    </div>
                                </div>
                            </div><!-- ttm-box-view-overlay end-->
                        </div><!-- featured-imagebox -->
                    </div>
                    <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                        <!-- featured-imagebox -->
                        <div class="featured-imagebox featured-imagebox-portfolio">
                            <!-- featured-thumbnail -->
                            <div class="featured-thumbnail">
                                <a href="#"> <img class="img-fluid" src="/img/fam.png" alt="image"></a>
                            </div><!-- featured-thumbnail end-->
                            <!-- ttm-box-view-overlay -->
                            <div class="ttm-box-view-overlay ttm-portfolio-box-view-overlay">
                                <div class="featured-iconbox ttm-media-link">
                                    <a class="ttm_prettyphoto ttm_image" title="Farm" data-rel="prettyPhoto" href="/img/fam.png">
                                        <i class="ti ti-search"></i>
                                    </a>
                                </div>
                                <div class="ttm-box-view-content-inner">
                                    <div class="featured-content featured-content-portfolio">
                                        <div class="featured-title">
                                            <h5><a href="#">Farmland</a></h5>
                                        </div>
                                        <!-- <span class="category">
                                            <a href="portfolio-category.html">Anesthesiology</a>,
                                            <a href="portfolio-category.html">Orthopedics</a>
                                        </span> -->
                                    </div>
                                </div>
                            </div><!-- ttm-box-view-overlay end-->
                        </div><!-- featured-imagebox -->
                    </div>
                    <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                        <!-- featured-imagebox -->
                        <div class="featured-imagebox featured-imagebox-portfolio">
                            <!-- featured-thumbnail -->
                            <div class="featured-thumbnail">
                                <a href="#"> <img class="img-fluid" src="/img/pon.png" alt="image"></a>
                            </div><!-- featured-thumbnail end-->
                            <!-- ttm-box-view-overlay -->
                            <div class="ttm-box-view-overlay ttm-portfolio-box-view-overlay">
                                <div class="featured-iconbox ttm-media-link">
                                    <a class="ttm_prettyphoto ttm_image" title="fish pond" data-rel="prettyPhoto" href="/img/pon.png">
                                        <i class="ti ti-search"></i>
                                    </a>
                                </div>
                                <div class="ttm-box-view-content-inner">
                                    <div class="featured-content featured-content-portfolio">
                                        <div class="featured-title">
                                            <h5><a href="#">Fish Pond</a></h5>
                                        </div>
                                        <!-- <span class="category">
                                            <a href="portfolio-category.html">Cardiology</a>,
                                            <a href="portfolio-category.html">Pharmacy</a>
                                        </span> -->
                                    </div>
                                </div>
                            </div><!-- ttm-box-view-overlay end-->
                        </div><!-- featured-imagebox -->
                    </div>
                    <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                        <!-- featured-imagebox -->
                        <div class="featured-imagebox featured-imagebox-portfolio">
                            <!-- featured-thumbnail -->
                            <div class="featured-thumbnail">
                                <a href="#"> <img class="img-fluid" src="/img/gl.png" alt="image"></a>
                            </div><!-- featured-thumbnail end-->
                            <!-- ttm-box-view-overlay -->
                            <div class="ttm-box-view-overlay ttm-portfolio-box-view-overlay">
                                <div class="featured-iconbox ttm-media-link">
                                    <a class="ttm_prettyphoto ttm_image" title="farmland" data-rel="prettyPhoto" href="/img/gl.png">
                                        <i class="ti ti-search"></i>
                                    </a>
                                </div>
                                <div class="ttm-box-view-content-inner">
                                    <div class="featured-content featured-content-portfolio">
                                        <div class="featured-title">
                                            <h5><a href="#">Farm Estate</a></h5>
                                        </div>
                                        <!-- <span class="category">
                                            <a href="portfolio-category.html">Anesthesiology</a>,
                                            <a href="portfolio-category.html">Pediatric</a>
                                        </span> -->
                                    </div>
                                </div>
                            </div><!-- ttm-box-view-overlay end-->
                        </div><!-- featured-imagebox -->
                    </div>
                    <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                        <!-- featured-imagebox -->
                        <div class="featured-imagebox featured-imagebox-portfolio">
                            <!-- featured-thumbnail -->
                            <div class="featured-thumbnail">
                                <a href="#"> <img class="img-fluid" src="/img/gal.png" alt="image"></a>
                            </div><!-- featured-thumbnail end -->
                            <!-- ttm-box-view-overlay -->
                            <div class="ttm-box-view-overlay ttm-portfolio-box-view-overlay">
                                <div class="featured-iconbox ttm-media-link">
                                    <a class="ttm_prettyphoto ttm_image" title="farm work" data-rel="prettyPhoto" href="/img/gal.png">
                                        <i class="ti ti-search"></i>
                                    </a>
                                </div>
                                <div class="ttm-box-view-content-inner">
                                    <div class="featured-content featured-content-portfolio">
                                        <div class="featured-title">
                                            <h5><a href="#">Harvesting</a></h5>
                                        </div>
                                        <!-- <span class="category">
                                            <a href="portfolio-category.html">Oncology</a>,
                                            <a href="portfolio-category.html">Pharmacy</a>
                                        </span> -->
                                    </div>
                                </div>
                            </div><!-- ttm-box-view-overlay end-->
                        </div><!-- featured-imagebox -->
                    </div>
                     
                    <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                        <!-- featured-imagebox -->
                        <div class="featured-imagebox featured-imagebox-portfolio">
                            <!-- featured-thumbnail -->
                            <div class="featured-thumbnail">
                                <a href="#"> <img class="img-fluid" src="/img/mac.png" alt="image"></a>
                            </div><!-- featured-thumbnail end -->
                            <!-- ttm-box-view-overlay -->
                            <div class="ttm-box-view-overlay ttm-portfolio-box-view-overlay">
                                <div class="featured-iconbox ttm-media-link">
                                    <a class="ttm_prettyphoto ttm_image" title="oil processing" data-rel="prettyPhoto" href="/img/mac.png">
                                        <i class="ti ti-search"></i>
                                    </a>
                                </div>
                                <div class="ttm-box-view-content-inner">
                                    <div class="featured-content featured-content-portfolio">
                                        <div class="featured-title">
                                            <h5><a href="#">Essential oil extraction</a></h5>
                                        </div>
                                        <!-- <span class="category">
                                            <a href="portfolio-category.html">Anesthesiology</a>,
                                            <a href="portfolio-category.html">Pediatric</a>
                                        </span> -->
                                    </div>
                                </div>
                            </div><!-- ttm-box-view-overlay end-->
                        </div><!-- featured-imagebox -->
                    </div>
                    <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                        <!-- featured-imagebox -->
                        <div class="featured-imagebox featured-imagebox-portfolio">
                            <!-- featured-thumbnail -->
                            <div class="featured-thumbnail">
                                <a href="#"> <img class="img-fluid" src="/img/rab.png" alt="image"></a>
                            </div><!-- featured-thumbnail end -->
                            <!-- ttm-box-view-overlay -->
                            <div class="ttm-box-view-overlay ttm-portfolio-box-view-overlay">
                                <div class="featured-iconbox ttm-media-link">
                                    <a class="ttm_prettyphoto ttm_image" title="Rabbit" data-rel="prettyPhoto" href="/img/rab.png">
                                        <i class="ti ti-search"></i>
                                    </a>
                                </div>
                                <div class="ttm-box-view-content-inner">
                                    <div class="featured-content featured-content-portfolio">
                                        <div class="featured-title">
                                            <h5><a href="#">Rabbitery Center</a></h5>
                                        </div>
                                        <!-- <span class="category">
                                            <a href="portfolio-category.html">Cardiology</a>,
                                            <a href="portfolio-category.html">Oncology</a>
                                        </span> -->
                                    </div>
                                </div>
                            </div><!-- ttm-box-view-overlay end-->
                        </div><!-- featured-imagebox -->
                    </div>
                </div><!-- row end -->
            </div>
        </section>

        
      </div>

   </app-master>
</template>

<script>
// @ is an alias to /src
import Master from "@/components/Master.vue"
import Breadcrumb from "@/components/Breadcrumb.vue"
import { seo } from "../Repositories/seo"

export default {
  name: "Faq",
  mixins: [seo],
  components: {
    "app-master" : Master,
    "app-breadcrumb" : Breadcrumb

  },
  created(){
      this.seoMetaData('Gallery', '');
  }

};
</script>
